import { useCallback, useEffect, useState } from "react";
import {
  Input,
  Form,
  Button,
  Select,
  Upload,
  Divider,
  notification,
} from "antd";
import { useNavigate } from "react-router-dom";

import { Warning2, DocumentUpload } from "iconsax-react";
import {
  ref as sRef,
  uploadBytes,
  getDownloadURL,
  getStorage,
} from "firebase/storage";
import Swal from "sweetalert2";

import PageHeader from "../../../components/PageHeader";

import { useProfiles } from "../../../hooks/profile";
import { useAuth } from "../../../hooks/auth";

import { Container, Main } from "./styles";
import Footer from "../../../components/Footer";
import Breadcrumb from "../../../components/Breadcrumb";

function geraStringAleatoria(tamanho: number) {
  let stringAleatoria = "";
  const caracteres =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (let i = 0; i < tamanho; i += 1) {
    stringAleatoria += caracteres.charAt(
      Math.floor(Math.random() * caracteres.length)
    );
  }
  return stringAleatoria;
}

function ProfileForm() {
  const { getAll, createProfiles, loadingProfiles } = useProfiles();
  const navigate = useNavigate();

  const { user } = useAuth();

  useEffect(() => {
    async function loadData() {
      if (!user?.uid) return;
      try {
        await getAll(user.uid);
      } catch (error) {
        navigate("/");
      }
    }
    loadData();
  }, [getAll, navigate, user?.uid]);

  const [name] = useState("");
  const [email] = useState("");
  const [password] = useState("");
  const [avatar, setAvatar] = useState("");
  const [telefone] = useState("");
  const [institution, setInstitution] = useState("Selecione uma instituição");
  const [loading, setLoading] = useState(false);

  const customUpload = async ({ file }: any) => {
    setLoading(true);
    const storage = getStorage();
    const metadata = {
      contentType: "image/jpeg",
    };

    const nick = geraStringAleatoria(16);
    const imageName = user?.uid;
    const imgFile = sRef(storage, `avatar/${imageName + nick}.png`);
    Swal.fire({
      title: "Realizando envio...",
      showConfirmButton: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        const runUpload = async () => {
          Swal.showLoading();
          try {
            await uploadBytes(imgFile, file, metadata);
            setLoading(false);
            const downloadUrl = await getDownloadURL(imgFile);
            setAvatar(downloadUrl);
            Swal.close();
            Swal.fire({
              icon: "success",
              showConfirmButton: false,
              timer: 1000,
            });
          } catch (e) {
            setLoading(false);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Aconteceu algum erro inesperado.\nTente novamente.",
            });
            console.error("Upload failed:", e);
          }
        };
        runUpload();
      },
    });
  };
  interface FormProps {
    uid: string;
    name: string;
    email: string;
    password: string;
    telefone: string;
    institution: string;
  }

  const openNotification = () => {
    notification.open({
      icon: <Warning2 size={18} />,
      message: (
        <h3 style={{ color: "red" }}>
          Atenção! <br />
          Campos Vazios.
        </h3>
      ),
      description:
        "Parece que um ou mais campos estão vazios. Preencha os campos destacados e clique novamente em cadastrar profissional",
      onClick: () => {
        console.log("Notification Clicked!");
      },
    });
  };

  const handleAddProfile = useCallback(
    async ({ name, email, password, telefone, institution }: FormProps) => {
      try {
        if (createProfiles) {
          await createProfiles({
            name,
            email,
            password,
            telefone,
            institution,
            avatar,
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    [createProfiles, avatar]
  );
  return (
    <Container id="page-profile-form">
      <PageHeader
        title="Adicionar novo Profissional."
        description="Preencha o formulário abaixo para adicionar um novo profissional"
        type="private"
      />
      <Main>
        <Breadcrumb
          items={[
            { label: "Gerenciamento de Profissionais", link: "/profile-list" },
            { label: "Novo Profissional", active: true },
          ]}
        />
        <Form
          onFinish={handleAddProfile}
          initialValues={{ remember: true }}
          onFinishFailed={openNotification}
        >
          <fieldset>
            <legend>Dados do Profissonal</legend>
            <Form.Item
              label="Nome Completo"
              name="name"
              rules={[
                {
                  required: true,
                  message: "O nome completo é obrigatório!",
                },
              ]}
            >
              <Input
                id="name"
                name="name"
                type="text"
                placeholder="Insira o nome do profissonal"
                value={name}
                allowClear
              />
            </Form.Item>

            <Form.Item
              label="Email"
              name="email"
              rules={[
                {
                  type: "email",
                  required: true,
                  message: "Email é obrigatório!",
                },
              ]}
            >
              <Input
                id="email"
                name="email"
                type="email"
                placeholder="Insira o email do profissonal"
                value={email}
                allowClear
              />
            </Form.Item>

            <Form.Item
              label="Senha (Mínimo de 06 caracteres)"
              name="password"
              rules={[
                {
                  required: true,
                  message:
                    "A senha é obrigatória e deve ter pelo menos 6 caracteres!",
                },
              ]}
            >
              <Input.Password
                id="password"
                minLength={6}
                allowClear
                name="password"
                placeholder="Insira uma senha pardrão"
                value={password}
                type="password"
              />
            </Form.Item>
            <Form.Item label="Foto para Identificação" name="avatar">
              <span> Formatos aceitos: (.png, .jpg, .jpeg)</span>
              <Divider />
              <Upload
                id="avatar"
                accept=".png, .jpg, .jpeg"
                name="avatar"
                maxCount={1}
                customRequest={customUpload}
                style={{ width: "100%" }}
                listType="picture"
              >
                <Button
                  block
                  loading={loading}
                  htmlType="button"
                  size="large"
                  type="dashed"
                  style={{
                    width: "100%",
                    textAlign: "start",
                    height: "5.6rem",
                    borderRadius: "0.8rem",
                  }}
                  icon={<DocumentUpload size={18} />}
                >
                  Realizar envio da imagem
                </Button>
              </Upload>
            </Form.Item>
            <Divider />
            <Form.Item
              label="Instituição que possui vínculo"
              name="institution"
            >
              <Select
                id="institution"
                style={{ marginBottom: "1.6rem" }}
                placeholder="Selecione uma instituição"
                value={institution !== "" ? institution : undefined}
                onChange={(value) => {
                  setInstitution(value);
                }}
                options={[
                  {
                    value: "1",
                    label: "Escola Cosme e Damião",
                  },
                  {
                    value: "2",
                    label: "Universidade Federal do Ceará",
                  },
                  {
                    value: "3",
                    label:
                      "Bilíngua Consultoria e Serviços de Informática LTDA",
                  },
                ]}
              />
            </Form.Item>
            <Form.Item
              label="Telefone para Contato ou Número para WhatsApp"
              name="telefone"
              rules={[{ required: true, message: "Telefone é obrigatório!" }]}
            >
              <Input
                id="telefone"
                type="tel"
                name="telefone"
                placeholder="Digite um número para contato"
                pattern="@^\(?\d{2}\)?[\s-]?[\s9]?\d{4}-?\d{4}$"
                value={telefone}
              />
            </Form.Item>
          </fieldset>

          <footer>
            <p style={{ color: "var(--color-warning)" }}>
              <Warning2 size={48} />
              Atenção! <br />É necessário preecher todos os dados.
            </p>
            <Button htmlType="submit" disabled={loadingProfiles}>
              Cadastrar profissional
            </Button>
          </footer>
        </Form>
      </Main>
      <Footer />
    </Container>
  );
}

export default ProfileForm;
